<template>
  <div class="share" v-if="share">
    <div class="share-mask"></div>
    <div class="icon-close" :class="type==0?'icon-close-bottom':''" @click="closeShareModel"></div>
    <div class="share-model-main">
      <div class="share-model-section">
        <div class="share-model-content">
          <div class="share-model-child1" v-if="type==0">
            <img class="img" :src="require('../../../static/img/share/arrow.png')" alt="">
            <p class="desc">点击右上角分享给好友</p>
          </div>
          <div class="share-model-child" v-else-if="type==1">

            <img :src="shareImg" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="share-model-bottom">
      <div class="share-bar">
        <div class="copy-url" :data-clipboard-text="shareUrl"> <img class="img" :src="require('../../../static/img/share/link@2x.png')" alt="">复制链接</div>
        <p class="desc" v-if="type==1">长按图片保存到手机或发送好友</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    propShareType: {
      type: Number,
      default: 0
    },
    propShare: {
      type: Boolean,
      default: false
    },
    propShareImg: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      share: false,
      type: 0,
      shareImg: "",
      copyBtn: null,
      shareUrl: window.location.href
    }
  },
  components: {

  },
  created() {

  },
  methods: {
    closeShareModel() {
      this.share = false;
      this.$emit('shareTarget', { share: false, shareType: 0 })
    },
    copyLink() {
      /*这是点击按钮触发的点击事件，关于clipboard的使用就不再赘述了，上面介绍时已经讲述过，并且使用方法在官方文档上有*/
      let _this = this;
      _this.$nextTick(function () {
        /*这里使用了刚开始注册到vue原型上的clipboard(使用注册到vue原型的插件的方法就是：this + 注册时命名名字)
        *这里需要用到刚才给button命名的ref的名字，因为这是vue提供的获取DOM的方法，虽然可以通过引入jQuery来获取，但是不推荐这样做，具体原因可以看官方文档和网上论坛搜索
        *这里是在挂载到DOM节点时将button按钮传入clipboard并存储起来，具体原因下面会有详述
        */
        _this.copyBtn = new _this.clipboard('.copy-url');
        let clipboard = _this.copyBtn;
        clipboard.on('success', function () {
          layer.open({
            content: '复制成功！'
            , skin: 'msg'
            , time: 1
          });
        });
        clipboard.on('error', function () {
          layer.open({
            content: '复制失败，请手动选择复制！'
            , skin: 'msg'
            , time: 1
          });
        });
      })
    }

  },
  mounted() {
    this.copyLink()
  },
  watch: {
    "propShare": function (curVal, oldVal) {
      this.share = curVal
    },
    "propShareType": function (curVal, oldVal) {
      this.type = curVal
    },
    "propShareImg": function (curVal, oldVal) {
      this.shareImg = curVal
    },
    '$route'(to, from) {//使用了缓存 导致发送请求的id不刷新，应该监控一下然后重新赋值id确保正确
      this.shareUrl = window.location.href
    },
  }
}
</script>
<style lang="scss" scoped>
.share-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.9);
}
.share-model-main * {
  box-sizing: content-box;
}
.share-model-main {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1001;
  display: table;
  pointer-events: none;
}
.share-model-section {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}
.icon-close {
  position: fixed;
  left: 50%;
  top: 0.8rem;
  width: 1.0133rem;
  height: 1.0133rem;
  margin-left: -0.5067rem;
  background: url(../../../static/img/hello_new/close.png) 0 no-repeat;
  background-size: 98% auto;
  z-index: 1001;
}
.icon-close-bottom{
  top:initial;
  bottom: 2.6667rem
}
.share-model-child {
  position: relative;
  display: inline-block;
  text-align: left;
  border-radius: 10px;
  -webkit-box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
  pointer-events: auto;
  -webkit-overflow-scrolling: touch;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-duration: 0.2s;
  animation-duration: 0.2s;
  padding: 0.2667rem 0.4rem 0.2667rem;
  text-align: center;
  border-radius: 6px;
  color: #333;
  background-color: #fff;
  -webkit-box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.3);
  box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.3);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
}
.share-model-child {
  width: 80%;
  max-width: 640px;
}
.share-model-child1 {
  position: absolute;
  top: 0.2667rem;
  width: 100%;
  right: 0.5333rem;
  color: #fff;
  font-size: 0.5333rem;
  text-align: right;
  .img {
    width: 2.6667rem;
  }
  .desc {
    margin-top: 0.2667rem;
  }
}
.share-model-bottom {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 100001;
}
.share-bar {
  display: flex;
  background-color: #fff;
  align-items: center;
  border-top-left-radius: 0.2133rem;
  border-top-right-radius: 0.2133rem;
  justify-content: center;
  .copy-url {
    padding: 0.2667rem  0.2667rem 0.2667rem 0.4rem;
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    font-size: 0.4267rem;
    img {
      width: 0.8rem;
      height: 0.8rem;
      margin-bottom: 0.1333rem;
    }
  }
  .desc {
    margin-left: 0.5333rem;
    line-height: 1.0667rem;
    text-align: center;
    font-size: 0.4267rem;
    color: #333;
    font-weight: 600;
  }
}
</style>